import React from 'react';
import PropTypes from 'prop-types';

import { isUndefined } from 'lodash';
import displayName from 'component-lib/displayName';

import { PrimaryButton } from 'v-c/Buttons';
import PaginationContainer from 'v-c/Pagination/PaginationContainer';
import Back from 'v-c/Pagination/Back';
import Next from 'v-c/Pagination/Next';
import withMessages from 'component-utilities/intl';
import styles from '../Dropdowns.scss';

const BASE_KEY = 'components.dropdowns.export.pagination';

function component({ getMessage, isDisabled, onBack, onNext, onSubmit }) {
    const isDefined = prop => !isUndefined(prop);
    return (
        <PaginationContainer extraClassName={styles['pagination-container']}>
            {isDefined(onBack) &&
            <Back extraClassName={styles['pagination-back']} onClick={onBack} />}
            {isDefined(onNext) &&
            <Next
                extraClassName={styles['pagination-next']}
                isDisabled={isDisabled}
                onClick={onNext}
            />}
            {isDefined(onSubmit) &&
            <span className={styles['pagination-button-right']}>
                <PrimaryButton
                    data-action="submit"
                    disabled={isDisabled}
                    onClick={onSubmit}
                >
                    {getMessage(`${BASE_KEY}.submit`)}
                </PrimaryButton>
            </span>}
        </PaginationContainer>
    );
}

component.propTypes = {
    getMessage: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool,
    onBack: PropTypes.func,
    onNext: PropTypes.func,
    onSubmit: PropTypes.func,
};

component.defaultProps = {
    isDisabled: void 0,
    onBack: void 0,
    onNext: void 0,
    onSubmit: void 0,
};

const ExportPagination = withMessages(component);

ExportPagination.displayName = displayName('Dropdowns/Export/ExportDropdownPagination',);

export default ExportPagination;
